import { createSlice } from "@reduxjs/toolkit";
import { getPropertiesEntry, getPropertiesTemplateService } from "../requests";
import { qrOptionsInitialState } from "../../constants/common";

const qrOptions = createSlice({
  name: "qrOptions",
  initialState: qrOptionsInitialState,
  reducers: {
    setErrorCorrectionLevel(state, { payload }) {
      state.errorCorrectionLevel = payload;
    },
    qrOptionsReset() {
      return qrOptionsInitialState;
    },
    setQrOptions(state, { payload }) {
      return {
        ...qrOptionsInitialState,
        ...payload,
      };
    },
  },
  extraReducers: {
    [getPropertiesEntry.fulfilled]: (state, { payload }) => {
      if (payload.data.qrOptions) {
        return {
          ...qrOptionsInitialState,
          ...payload.data.qrOptions,
        };
      }
    },
    [getPropertiesTemplateService.fulfilled]: (state, { payload }) => {
      if (payload.data.qrOptions) {
        return {
          ...qrOptionsInitialState,
          ...payload.data.qrOptions,
        };
      }
    },
  },
});
export const { setErrorCorrectionLevel, qrOptionsReset, setQrOptions } =
  qrOptions.actions;
export default qrOptions.reducer;
